var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_c('img',{attrs:{"src":require("../assets/Info.png"),"width":_vm.width,"title":_vm.tooltip,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }